import type { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useDesignVariant } from './DesignVariantProvider';

export const DesignPageIntro = ({
  area,
  action,
}: {
  area: 'campaigns' | 'profiles';
  action?: ReactNode;
}) => {
  const { variant } = useDesignVariant();
  if (variant === 'main' || area === 'profiles') return null;
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      gap={2}
      alignItems={{ sm: 'start' }}
      justifyContent="space-between">
      <Box>
        <Typography component="h1" variant="h3">
          {variant === 'v1' ? 'Your calling campaigns' : variant === 'v2' ? 'My team' : 'Campaigns'}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {variant === 'v2'
            ? 'Your assistants, campaigns and call results.'
            : 'Each campaign has its own conversation, phone setup and call results.'}
        </Typography>
      </Box>
      {action}
    </Stack>
  );
};
